import styled from 'styled-components'

export const getColumnWidthSize = (numberOfColumns) => {
  if (numberOfColumns === 4) {
    return {
      regular: '27%',
      small: '19%'
    }
  }
  if (numberOfColumns === 3) {
    return {
      regular: 'calc(100% / 3)',
      small: 'calc(100% / 3)'
    }
  }
  if (numberOfColumns === 2) {
    return {
      regular: 'calc(2 / 3 * 100%)',
      small: 'calc(1 / 3 * 100%)'
    }
  }
  return {
    regular: 'auto',
    small: 'auto'
  }
}

const DashboardWrap = styled.div`
  position: relative;
  min-width: ${({ numberOfColumns }) => numberOfColumns === 4 ? '1850px' : 'auto'} ;

  .dashboard-column {
    width: ${({ numberOfColumns }) => getColumnWidthSize(numberOfColumns).regular};

    &_small {
      width: ${({ numberOfColumns }) => getColumnWidthSize(numberOfColumns).small};
    }
  }
`

export default DashboardWrap
